export default __webpack_public_path__ + "8a195d7551bcda674934dcd86fd2246d.svg";